import s from "./additionalComment.module.css";
import {nadWhiteArrow} from "../../../../../assets";
import {useAppContext} from "../../../../../contexts";

const AdditionalComment = (props) => {
    // Destructured props
    const {
        formValues,
        handleChange
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <div
            className={`flex flex-col items-start w-full gap-y-4 overflow-hidden ${formValues.answer === "0" ? s.animation : "max-h-0"}`}>
            <h2 className={`${s.heading} ${highContrast ? "!text-white" : ""}`}>
                Diga-nos o que você não encontrou:
            </h2>
            <textarea
                name="additionalComment"
                value={formValues.additionalComment}
                placeholder={"Por favor, qual foi o serviço que você precisava na nossa loja virtual"}
                className={s.textArea}
                onInput={e => handleChange(e)}
            />
            <button
                type={"submit"}
                className={`${s.submitButton} ${highContrast ? "highFormButton" : ""}`}
            >
                Prosseguir
                <img
                    src={nadWhiteArrow}
                    alt="White arrow"
                />
            </button>
        </div>
    )
}

export default AdditionalComment;
